import styled from 'styled-components';

export const Container = styled.section`
  margin: 0;
`;

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 0.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 1rem 2rem 1rem 2rem;
  }

  & > span {
    font-family: ${({ theme }) => theme.fonts.workSans};
    font-size: 1rem;
    font-weight: 400;
    width: 79%;
  }

  .hefesto-link {
    text-decoration: underline;
    font-size: 1rem;
    font-weight: bold;
  }
`;
